/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .has-error .k-picker-wrap{border-color:#e98f88;background-color:#fff6f5;box-shadow:inset 0 1px 2px 0 rgba(0,0,0,.2)}"];
export { styles as styles };
